import React from "react";
import { pt } from "date-fns/locale";
import { components } from "react-select";
import DatePicker from "react-datepicker";
import { BsChevronDown } from "react-icons/bs";
import { IoMdClose } from "react-icons/io";
import { DateTimeIcon } from "../../../../components/IconsSVG";
import "react-datepicker/dist/react-datepicker.css";
import styled from "styled-components";
import moment from "moment";

import {
  ContainerSelect2,
  DateContainer,
  InputContainer,
  StyledCreatableSelect2,
  StyledInput,
  StyledSelect2,
  TooltipBox,
  TooltipCard,
  TooltipText,
} from "./style";

import { ReactComponent as HelpCircle } from "../../../../assets/icons/help-circle.svg";
import { ReactComponent as TrashIcon } from "../../../../assets/icons/icon-trash.svg";
const dateTimeFormat = "DD/MM/YYYY";
const CustomDatePickerWrapper = styled.div`
  position: relative;

  .date-icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }
`;
function handleChangeDate(value) {
  if (value?.target) {
    value = value.target.value;
  }
  if (!value) {
    console.warn("The value provided is null or undefined.");
    return;
  }

  if (value instanceof Date) {
    return moment(value).format(dateTimeFormat);
  } else if (typeof value === "string") {
    try {
      const dateValue = moment(value, dateTimeFormat);
      if (dateValue.isValid()) {
        return dateValue.format(dateTimeFormat);
      } else {
        console.error("The date provided is invalid.");
      }
    } catch (e) {
      console.error("Error converting string to date:", e);
    }
  } else {
    console.error("Tipo de dado não suportado:", typeof value);
  }
}

export const CustomDatePicker = ({
  selectedDate,
  onChange,
  name,
  disabled,
}) => {
  return (
    <CustomDatePickerWrapper>
      <DatePicker
        selected={selectedDate ? new Date(selectedDate) : null}
        onChange={(value) =>
          onChange({ target: { name, value: handleChangeDate(value) } })
        }
        dateFormat="dd/MM/yyyy"
        locale={pt}
        popperPlacement="bottom-end"
        popperModifiers={poppupOptions}
        disabled={disabled}
        customInput={<StyledInput />}
      />
      <div className="date-icon">
        <DateTimeIcon />
      </div>
    </CustomDatePickerWrapper>
  );
};

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <BsChevronDown />
    </components.DropdownIndicator>
  );
};

const MultiValueRemove = (props) => {
  return (
    <components.MultiValueRemove {...props}>
      <div className="border">
        <IoMdClose size="8px" />
      </div>
    </components.MultiValueRemove>
  );
};

const ClearIndicator = (props) => {
  return (
    <components.ClearIndicator {...props}>
      <div className="border">
        <IoMdClose size="12px" />
      </div>
    </components.ClearIndicator>
  );
};

const NoOptionsMessage = (props) => {
  return (
    <components.NoOptionsMessage {...props}>
      Sem opções
    </components.NoOptionsMessage>
  );
};

const poppupOptions = [
  {
    name: "offset",
    options: {
      offset: [-10, 0],
    },
  },
];

export const InputField = ({
  type,
  as,
  isMulti = false,
  creatable = false,
  name,
  placeholder,
  maxLength,
  value,
  options,
  onChange,
  required,
  isInvalid,
  isClearable,
  disabled,
  style,
  label,
  children,
  accept,
  fade,
  tooltip,
  tooltipText,
  trash,
  handleClearInput,
  onCreateOption,
  height,
  rows,
  ref = null
}) => {
  return type === "date" ? (
    <DateContainer>
      <CustomDatePicker
        selectedDate={value}
        name={name}
        onChange={(value) =>
          onChange({ target: { name, value: handleChangeDate(value) } })
        }
        disabled={disabled}
      />
      {label && (
        <span className="label">
          {label} {required && <span className="required">*</span>}
        </span>
      )}
    </DateContainer>
  ) : as !== "select2" ? (
    <InputContainer className={fade ? "fade" : ""}>
      <StyledInput
        type={type ? type : "text"}
        as={as}
        rows={rows}
        height={height}
        accept={accept}
        autoComplete="off"
        name={name}
        placeholder={placeholder ? placeholder : "Digite os dados"}
        maxLength={maxLength}
        isClearable={isClearable}
        style={style}
        value={value}
        isInvalid={isInvalid}
        onChange={onChange}
        required={required}
        disabled={disabled}
        ref={ref}
        className={
          as === "select" && value === ""
            ? "placeholder"
            : as === "textarea" && isInvalid
              ? "is-invalid"
              : ""
        }
      >
        {children}
      </StyledInput>

      {label && (
        <span className={`label ${disabled ? "disabled" : ""}`}>
          {label} {required && <span className="required">*</span>}
          {tooltip && (
            <TooltipCard>
              <TooltipText>
                <HelpCircle />
              </TooltipText>
              <TooltipBox>
                <div>{tooltipText}</div>
              </TooltipBox>
            </TooltipCard>
          )}
        </span>
      )}
      {as === "select" && <div className="chevron">{<BsChevronDown />}</div>}
      {trash && (
        <div className="trash" onClick={handleClearInput}>
          <TrashIcon fill="#9e37e2" />
        </div>
      )}
    </InputContainer>
  ) : creatable ? (
    <ContainerSelect2>
      <StyledCreatableSelect2
        classNamePrefix="select"
        isMulti={isMulti}
        value={value}
        placeholder={placeholder}
        closeMenuOnSelect={true}
        name={name}
        options={options}
        onChange={onChange}
        isDisabled={disabled}
        onCreateOption={onCreateOption}
        isCreatable={true}
        isClearable={true}
        formatCreateLabel={(newItem) => (
          <span className="select__create-option">{`Criar ${newItem}...`}</span>
        )}
        components={{
          DropdownIndicator,
          MultiValueRemove,
          ClearIndicator,
          NoOptionsMessage,
        }}
      />
      <span className="label">
        {label} {required && <span className="required">*</span>}
      </span>
    </ContainerSelect2>
  ) : (
    <ContainerSelect2>
      <StyledSelect2
        classNamePrefix="select"
        isMulti={isMulti}
        value={value}
        placeholder={placeholder}
        closeMenuOnSelect={true}
        name={name}
        options={options}
        onChange={onChange}
        isDisabled={disabled}
        components={{
          DropdownIndicator,
          MultiValueRemove,
          ClearIndicator,
          NoOptionsMessage,
        }}
      />
      <span className="label">
        {label} {required && <span className="required">*</span>}
      </span>
    </ContainerSelect2>
  );
};
